import hash from '~/misc/hash'
export const getQuery = (url) => {
  const arrQuerys = url.split('?');
  if (arrQuerys.length < 2) {
    return false;
  }
  const queryObj = {};
  for (let i = 0; i < arrQuerys.length; i++) {
    let arrQueryItemArr = arrQuerys[i].split('=');
    queryObj[arrQueryItemArr[0].replace(/^\s+|\s+$/g, '')] = arrQueryItemArr[1]
      ? arrQueryItemArr[1].replace(/^\s+|\s+$/g, '')
      : arrQueryItemArr[1];
  }
  return queryObj;
};


export const removeQuery = (queryStrings) => {
  const oldQuery = new URLSearchParams(window.location.search);
  let removedQuery = [];
  queryStrings.map(query => {
    removedQuery.push(oldQuery.get(query) || null)
    oldQuery.delete(query);
  })
  history.replaceState({}, "", window.location.pathname +"?"+ oldQuery.toString())
  return removedQuery
} 

export const setDeeplink = (link) => {
  const id = hash(8);
  window.localStorage.setItem("TLEmailDeeplink", JSON.stringify({
    id,
    link,
  }))
  return id;
} 

export const getDeeplink = (hash) => {
  const deeplink = window.localStorage.getItem("TLEmailDeeplink");
  if(!deeplink) return null;
  const { id, link } = JSON.parse(deeplink);
  if(id !== hash) return null;
  return link
}


// WEBPACK FOOTER //
// ./src/misc/getQuery.js